import { useContext, createContext } from 'react';

var FieldControlContext = /*#__PURE__*/createContext(null);
var useFieldControlContext = function useFieldControlContext() {
  return useContext(FieldControlContext);
};

export { FieldControlContext, useFieldControlContext };
